// Brand logo asset — served from /public/aeroguard-logo.png
// Variants:
//   variant="full"  → shield + "AeroGuard" wordmark + tagline (default)
//   variant="mark"  → just the shield illustration (icon-only, no wordmark)
//
// The source PNG contains the shield illustration on top and the wordmark
// underneath. For "mark" we crop to the top ~55 % of the image via CSS
// (object-position + aspect-ratio), which is why we use `object-cover`.
export default function BrandLogo({ variant = 'full', className = '', ...rest }) {
  const src = '/aeroguard-logo.png';
  if (variant === 'mark') {
    // Icon-only — crop to the top shield portion.
    return (
      <span
        className={`inline-block overflow-hidden ${className}`}
        style={{ aspectRatio: '1 / 1' }}
        aria-label="AeroGuard"
        {...rest}
      >
        <img
          src={src}
          alt="AeroGuard"
          className="w-full h-auto"
          style={{ marginTop: '-4%', width: '150%', marginLeft: '-25%' }}
          draggable={false}
        />
      </span>
    );
  }
  return (
    <img
      src={src}
      alt="AeroGuard — Safe Skies. Smarter Future."
      className={`select-none ${className}`}
      draggable={false}
      {...rest}
    />
  );
}
